import { makeStyles } from 'makeStyles';
import { WHITE } from 'theme/colors';

export const useStyles = makeStyles()((theme) => ({
  root: {
    border: '1px solid #dadce0',
    borderRadius: 2,
    '& button': {
      margin: 0,
    },
  },
  input: {
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    position: 'relative',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // font-family: Avenir-Roman;
    fontSize: 15,
    lineHeight: 1.5,
    padding: `9px 26px 8px 12px`,
    fontWeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#3e424e',
    '&:focus': {
      borderRadius: 2,
      backgroundColor: theme.palette.background.paper,
    },
  },
  clearIcon: {
    '&:hover': {
      background: 'transparent',
    },
  },
  searchIcon: {
    padding: '0 8px 0 0',
    '&:hover': {
      background: 'transparent',
    },
  },
}));

export const organisationIconStyle = {
  '& path': {
    stroke: WHITE,
  },
};
